import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { ThemeProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { appRoutes, oktaConfigs } from "./constants/ApplicationConstants";
import AuthMiddleware from "./middlewares/AuthMiddleware";
import ExploreScreen from "./screens/user/ExploreScreen";
import LogoutScreen from "./screens/user/LogoutScreen";
import MenuScreen from "./screens/user/MenuScreen";
import ChatScreen from "./screens/user/ChatScreen";
import TenantScreen from "./screens/others/TenantScreen";
import InsightsScreen from "./screens/user/InsightsScreen";
import AdminPanelScreen from "./screens/admin/AdminPanelScreen";
import { ErrorScreen } from "./screens/others/ErrorScreen";
import './App.css';


function App() {
  const { muiTheme } = useSelector(state=> state.user)

  const navigate = useNavigate()

  async function restoreOriginalUri(_oktaAuth, originalUri) {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  }

  return (
    <>
      {muiTheme&&<ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <Security oktaAuth={new OktaAuth({
              issuer: oktaConfigs.oktaDomain,
              clientId: oktaConfigs.oktaClientId,
              redirectUri: window.location.origin + oktaConfigs.oktaRedirectURL
        })} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path={oktaConfigs.oktaRedirectURL} element={<LoginCallback/>} />
            <Route path={appRoutes.logout} element={<LogoutScreen />} />
            <Route path={appRoutes.errorRoute} element={< ErrorScreen/>} />
            <Route path={appRoutes.tenant} element={<TenantScreen />} />
            <Route element={<AuthMiddleware allowedRoles={[1,2]} />}>
              <Route path={appRoutes.home} element={<ExploreScreen />} />
              <Route path={appRoutes.explore} element={<ExploreScreen />} />
              <Route path={appRoutes.menu} element={<MenuScreen />} />
              <Route path={appRoutes.chat} element={<ChatScreen />} />
              <Route path={appRoutes.insights} element={<InsightsScreen />} />
            </Route>
            <Route element={<AuthMiddleware allowedRoles={[2]} />}>
              <Route path={appRoutes.adminPanel} element={<AdminPanelScreen />} />
            </Route>
          </Routes>
        </Security>
      </ThemeProvider>
      }
    </>
  );
}
export default App;
